export const DEFAULT_LOCALE = 'en-AU';
